import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { UniformsPageHeader, UniformsTable } from '@/components/pages/Uniforms/List'
import routes from '@/constants/routes'
import useQueryPage from '@/hooks/useQueryPage'

import { useUniforms } from './Uniforms.hook'

const Uniforms = () => {
  const currentPage = useQueryPage()
  const navigate = useNavigate()
  const { getUniforms, getUniformsLoading, getUniformsResponse, page, pageSize, setPage } = useUniforms()

  const dataSource = getUniformsResponse?.items ?? []
  const totalItems = getUniformsResponse?.meta.totalItems || 0

  const handleChangePage = (config: TablePaginationConfig) => {
    setPage(config.current ?? page)
    navigate({
      pathname: routes.uniforms.path,
      search: `?page=${config.current ?? page}`,
    })
  }

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, setPage])

  useEffect(() => {
    getUniforms().then()
  }, [getUniforms])

  return (
    <>
      <UniformsPageHeader />
      <UniformsTable {...{ dataSource, getUniformsLoading, page, totalItems, pageSize }} onChange={handleChangePage} />
    </>
  )
}

Uniforms.displayName = 'Uniforms'
export default Uniforms
